// Get the target element
const lottiePlayer = document.querySelectorAll(".lottie-player-animation");

// Options for the Intersection Observer
const options = {
  root: null, // Use the viewport as the root
  rootMargin: '0px', // No margin
  threshold: 0.5 // Trigger when 50% of the target is visible
};

// Callback function to handle intersection changes
const callback = (entries, observer) => {
  entries.forEach(entry => {
    const lottiePlayer = entry.target;
    if (entry.isIntersecting) {
      // The target element is in the viewport
      lottiePlayer.play();
    } else {
      // The target element is not in the viewport
      lottiePlayer.stop();
    }
  });
};

// Create an Intersection Observer with the callback and options
const observer = new IntersectionObserver(callback, options);

// Start observing the target element
lottiePlayer.forEach(lottiePlayer => {
  observer.observe(lottiePlayer);
});

